import styled from 'styled-components'

type PreventPageBreakProps = {
  shouldAvoidPageBreak?: boolean
  breakBefore?: boolean
}

export const PreventPageBreak = styled.div<PreventPageBreakProps>`
  @media print {
    break-before: ${({ breakBefore }) => (breakBefore ? 'page' : 'auto')};
    break-inside: ${({ shouldAvoidPageBreak }) =>
      shouldAvoidPageBreak ? 'avoid' : 'auto'};
  }
`

export const HiddenInPrint = styled.div`
  @media print {
    visibility: hidden;
  }
`

export const RemovedInPrint = styled.div`
  @media print {
    display: none;
  }
`

/**
 * Why 14cm? Honstly I'm not 100% sure. It just seems to work.
 * Responsive print previews seem quite dodgy. I'm confident this
 * will be replaced by someone smarter than me one day!
 */
export const ShowPrintA4 = styled.div`
  display: none;

  @media print and (min-width: 14cm) {
    display: block;
  }
`

export const HidePrintA4 = styled.div`
  display: block;

  @media print and (min-width: 14cm) {
    display: none;
  }
`

export default PreventPageBreak
